import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  Button, Card, Col, Row,
} from 'antd';
import ArticuloFotoGrid from '../../../articulos/containers/BuscadorArticulos';
import ArticuloFittingBox from '../../../articulos/components/dataDisplay/ArticuloFittingBox.datadisplay';
import { Box, Text } from '../../../shared/components';
import { findLineaFromEncargo } from '../../lib/busquedas.lib';
import { addArticulo } from '../../../../state/actions/creators/encargos.creador.actioncreator';
import TwoColumnsFlexLayout from '../../../shared/components/layout/TwoColumnsFlex.layout';
import { isTablet, isTotem } from '../../../../helpers/device.helper';
import Page from "../../../shared/components/layout/Page.layout";


class EncargosCrearFittingbox extends Component {
  constructor(props, context) {
    super(props, context);
    const { articuloSeleccionado } = props;
    this.state = {
      articuloSeleccionado,
    };
  }

  componentDidMount() {
    const { history, articuloSeleccionado } = this.props;
    if (articuloSeleccionado === undefined) {
      history.goBack();
    }
    this.setState({ articuloSeleccionado });
  }

  render() {
    const {
      cdgtipo, addArticulo, encargoUUID, linea, history,
    } = this.props;
    const { articuloSeleccionado } = this.state;
    if (articuloSeleccionado === undefined) {
      return <div />;
    }
    const { id: articuloSeleccionadoId } = articuloSeleccionado;
    let gluedFilter;
    gluedFilter = {
      'tipo.id': { valor: cdgtipo },
    };

    const flexLeft = (isTablet() && !isTotem()) ? 1 : 3;
    let containerStyle = {};
    const fitingboxHeight = Math.round(window.screen.height * 0.45);
    let paginationProps = {};
    let totemOTablet = false;
    if (isTotem() || isTablet()) {
      totemOTablet = true;
      containerStyle = {
        height: fitingboxHeight + 16,
        overflow: 'hidden',
        overflowY: 'scroll',
      };
      paginationProps = {
        size: 'small',
        style: {
          height: '32px',
        },
      };
    }

    let numeroDeArticulos = 12;
    if (isTotem()) numeroDeArticulos = 9;

    return (
      <Page
        tituloTraduccionId="encargos.seleccionar_articulo"
        navigationItems={[
          {
            node: <Text translationId="navegacion.home" />,
            link: '',
          },
          {
            node: <Text translationId="navegacion.encargos" />,
          },
        ]}
      >
        <TwoColumnsFlexLayout
          flexLeft={flexLeft}
          leftContent={(
            <Box>
              <Card
                style={{
                  borderRightWidth: totemOTablet ? '0px' : '1px',
                }}
              >
                <ArticuloFittingBox
                  height={fitingboxHeight}
                />
                <Box pt="16">
                  <Button
                    block
                    type="primary"
                    onClick={() => {
                      addArticulo({ articulo: articuloSeleccionado, encargoUUID, linea });
                      history.replace('/encargos/crear');
                    }}
                  >
                    Quiero esta montura
                  </Button>
                </Box>
              </Card>
            </Box>
          )}
          rightColumnStyle={{ paddingLeft: totemOTablet ? '0px' : '16px' }}
          rightContent={(
            <Box style={{ height: fitingboxHeight, minWidth: '280px' }}>
              <ArticuloFotoGrid
                bodyProps={{ style: { borderLeftWidth: totemOTablet ? '0px' : '1px' } }}
                paginationProps={paginationProps}
                containerStyle={containerStyle}
                filtrosDesactivados
                searchable={false}
                reload={false}
                modoVisualizacion="grid"
                seleccionId={articuloSeleccionadoId}
                numeroDeArticulos={numeroDeArticulos}
                gluedFilter={gluedFilter}
                endpoint="BUSCADOR_ARTICULOS_CREAR_ENCARGO_PAGE"
                onSeleccion={({ articulo }) => this.setState({ articuloSeleccionado: articulo })}
              />
            </Box>
          )}
        />
      </Page>
    );
  }
}


function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    addArticulo,
  }, dispatch);
}

const mapStateToProps = (state, ownProps) => {
  const { encargosCreador: { encargos }, grideable } = state;
  const { match } = ownProps;
  const {
    params: {
      encargoUUID, cdgtipo, linea, seleccion,
    },
  } = match;

  const detalle = findLineaFromEncargo({ encargos, uuid: encargoUUID, linea });
  let articuloSeleccionado;
  const grideableArticulos = grideable.BUSCADOR_ARTICULOS_CREAR_ENCARGO_PAGE;
  if (grideableArticulos) {
    articuloSeleccionado = grideableArticulos.datos.find(articulo => articulo.codigo === seleccion);
  }

  return {
    cdgtipo,
    encargoUUID,
    linea,
    articuloSeleccionado,
    detalleSeleccionado: detalle,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EncargosCrearFittingbox);
